import React from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";

export default function ManageBillingButton({ className = "", testId = "manage-billing-btn", label = "Manage Billing Portal", accountParam = "" }) {
  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/billing/portal${accountParam ? `?${accountParam}` : ""}`, { return_url: window.location.href });
      if (data.is_demo) {
        toast.info("Demo mode", {
          description: "The billing portal isn't connected yet. Please contact your BoxHero rep to enable payments.",
        });
        return;
      }
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not open billing portal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={handleClick}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 active:scale-[0.98] disabled:opacity-60 text-white font-semibold px-5 py-2.5 rounded-md transition-all ${className}`}
    >
      {loading ? "Opening…" : label}
      <ExternalLink className="w-4 h-4" />
    </button>
  );
}
